import React, { useState } from 'react';
import farm1 from '../assets/farm1.jpeg';
import farm2 from '../assets/farm2.jpeg';
import farm3 from '../assets/farm3.jpeg';
import farm4 from '../assets/farm4.jpeg';
import farm5 from '../assets/farm5.jpeg';
import farm6 from '../assets/farm6.jpeg';
import farm7 from '../assets/farm7.jpeg';
import farm8 from '../assets/farm8.jpeg';

function OurOrganicFarms() {
  const images = [farm1, farm2, farm3, farm4, farm5, farm6, farm7, farm8];
  const [isPaused, setIsPaused] = useState(false);

  return (
    <section style={{ 
      backgroundColor: '#ffffff', 
      padding: '80px 20px 120px 20px', 
      fontFamily: 'system-ui, sans-serif',
      overflow: 'hidden'
    }}>
      {/* Title Headers */}
      <div style={{ textAlign: 'center', marginBottom: '80px' }}>
        <p style={{ color: '#16803d', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '2px', fontSize: '13px', marginBottom: '12px' }}>
          OUR ORGANIC FARMS
        </p>
        <h2 style={{ fontSize: '36px', color: '#1e293b', margin: '0 0 16px 0', fontWeight: '800' }}>
          Real Farm Fresh Organic Farming
        </h2>
        <p style={{ color: '#64748b', maxWidth: '600px', margin: '0 auto', lineHeight: '1.6' }}>
          Take a look at our real organic farms, fresh harvesting process, and healthy natural farming methods.
        </p>
      </div>

      {/* 3D PERSPECTIVE VIEWPORT VIEW */}
      <div style={{
        perspective: '1200px', // Creates the depth of the 3D world
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '350px',
        position: 'relative'
      }}>
        
        {/* ROTATING CAROUSEL CYLINDER */}
        <div 
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
          style={{
            width: '280px',
            height: '200px',
            position: 'absolute',
            transformStyle: 'preserve-3d',
            animation: isPaused ? 'none' : 'spin3D 25s linear infinite', // Infinite continuous loop
          }}
        >
          {images.map((imgSrc, index) => {
            // Calculate rotational positioning context for an 8-sided ring
            // 360 degrees / 8 images = 45 degrees step intervals
            const angle = index * 45; 
            // 360px translates the cards outward from the center point of the radius circle
            const translateZ = '360px'; 

            return (
              <div
                key={index}
                style={{
                  position: 'absolute',
                  width: '100%',
                  height: '100%',
                  left: 0,
                  top: 0,
                  borderRadius: '16px',
                  overflow: 'hidden',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
                  transform: `rotateY(${angle}deg) translateZ(${translateZ})`,
                  backfaceVisibility: 'visible', // Keeps rear floating images visible through the ring
                  border: '4px solid #ffffff',
                  transition: 'transform 0.5s ease, box-shadow 0.3s ease'
                }}
              >
                <img 
                  src={imgSrc} 
                  alt={`Farm view ${index + 1}`} 
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
                />
              </div>
            );
          })}
        </div>
      </div>

      {/* CSS KEYFRAMES INJECTOR FOR THE 3D ROTATION */}
      <style>{`
        @keyframes spin3D {
          from {
            transform: rotateY(0deg);
          }
          to {
            transform: rotateY(360deg);
          }
        }
      `}</style>

    </section>
  );
}

export default OurOrganicFarms;